import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "../../layouts/Layout";
import LoginPage from "../../../Pages/Login/Login";
import NotFound from "../../../Pages/NotFound/NotFound";
import ProtectedRoute from "../Routes/ProtectedRoute";
import ForgotPassword from '../../../Pages/resetPassword';
import UpdatePassword from "../../../Pages/updatePassword/UpdatePassword";




const AppRoutes = (props) => {
  return (
    <Router>
      <React.Suspense>
        <Routes>
          <Route name="Layout" path="/"
            element={
              <ProtectedRoute>
                <Layout componentRoutes={props.componentRoutes} />
              </ProtectedRoute>
            }
          >
            {props.componentRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                name={"test"}
                element={<route.component securityKey={route.securityKey} />}
              />
            ))}
          </Route>
          <Route exact name="Login" path="/login" element={<LoginPage />} />
          <Route exact name="ResetPaaword" path="/resetPassword" element={<ForgotPassword />} />
          <Route
            path="/updatePassword/*"
            element={<UpdatePassword />}
          />



          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Suspense>
    </Router>
  );
};
export default AppRoutes;
